$('tr.cart__row').each(function (i, v) {
    // get first <td>
    let first_child = $(this).children().first()
    // get detail from <td>
    let first_child_details = $(first_child).children().first().children().last().children().eq(1)
    
    // console.log(first_child_details);
    
    // this is for get Single Item or Multiple Items
    let prop_key = $(first_child_details).children().last().children().first().text().trim().toLocaleLowerCase()
    let prop_val = $(first_child_details).children().last().children().last().text().trim().toLocaleLowerCase()
    //

    // this for get Rent Price
    let prop_key_rent = $(first_child_details).children().first().text().trim().toLocaleLowerCase()
    //

    // this is for get Best Price
    let prop_key_best = $(first_child_details).children('.product-details__item.product-details__item--property').first().children().first().text().trim().toLocaleLowerCase()
    let prop_val_best = $(first_child_details).children('.product-details__item.product-details__item--property').first().children().last().text().trim().toLocaleLowerCase()
    // 

    if (prop_key.includes('multiple items')) {
      // console.log('wau', $('.cart__submit-controls input'));
      $('.cart__submit-controls input').replaceWith(`<a href="/checkout" class="cart__submit btn btn-primary btn--small-wide">Check out</a>`)
      if (prop_val.trim() == 'true') {
        $(this).hide()
      }
    }
    else if (prop_key.includes('single item')) {
      $(first_child_details).children().last().hide()

      prop_val_best = parseInt(prop_val_best.split(" ")[0])

      let third_child = $(this).children().eq(2)
      let kuantitas = parseInt($(third_child).children().first().children().last().val())

      console.log('ini nih', $(third_child));

      $(third_child).children().first().children().last().val(Math.ceil(kuantitas / prop_val_best))

      let second_child = $(v).children().eq(1)
      let second_child_harga = $(second_child).children().first().children().first().children().eq(1)

      $(second_child).children().eq(2).children('input').val(Math.ceil(kuantitas / prop_val_best))

      let hargana = parseInt($(second_child_harga).children()[1].innerHTML.trim().replace("$", "").replace(".", "").replace(",", ""))

      let temp_price = prop_val_best * hargana,
          temp_cent = temp_price.toString().slice(-2)

      temp_price = temp_price.toString().slice(0, -2)
      temp_price = `$${temp_price}.${temp_cent}`

      $(second_child_harga).children()[1].innerHTML = temp_price
    }

    // hide best price attribute
    if (prop_key_best.includes('best price')) {
      $(first_child_details).children('.product-details__item.product-details__item--property').first().hide()
      $(first_child_details).children('.product-details__item.product-details__item--property').eq(1).css('margin-top', '0.8rem')
    }
    // 

    // hide rent price and shipping-size attribute
    $(first_child_details).children('.product-details__item--variant-option').each(function(i, v){
      if ($(this).text().trim().toLocaleLowerCase().includes('rent price') || $(this).text().trim().toLocaleLowerCase().includes('shipping-size')){
        $(this).hide()
      }
    })
    // 
  })

let cart3 = jQuery.getJSON('/cart.js');
cart3.done(() => {
  cart3 = cart3.responseJSON
  let aytem = cart3.items

  let filter_aytem = aytem.filter((v) => {
    if (v.properties != null) {
      if ('Multiple items' in v.properties) {
        return v
      }
    }
  })

  console.log({filter_aytem});

  let prev,
      total_harga = 0,
      variants = [],
      qtyna
  filter_aytem = filter_aytem.map((v, i) => {
    if (i == 0){
      prev = i
    }

    if (v.variant_title.includes('Weekly')) {
      qtyna = v.quantity
    }
    
    total_harga += v.price * v.quantity
    variants.push(v.variant_id)
    if (i % 2 != 0 && prev == i - 1) {
      let sum_price = total_harga.toString(),
          cent = sum_price.slice(-2)
      sum_price = `${sum_price.slice(0, -2)}.${cent}`

      let parians = variants.join("_")
      variants = []
      // console.log({cent});
      total_harga = 0
      prev = i + 1
      return {
        key: v.key,
        url: v.url,
        title: v.title,
        quantity: qtyna,
        image: v.image,
        product_title: v.product_title,
        best_price: v.properties['Best Price'],
        product_type: v.product_type,
        type: v.options_with_values.length >= 3 ? v.options_with_values[1].value : null,
        shipping_size: v.options_with_values.length >= 3 ? v.options_with_values[2].value : v.options_with_values[1].value,
        Start: v.properties['Start'],
        End: v.properties['End'],
        price: sum_price,
        variant_ids: parians
      }
    }
  })

  filter_aytem = filter_aytem.filter((v) => v !== undefined)

  console.log({filter_aytem});

  filter_aytem.forEach((v) => {
    let {
      key, 
      url, 
      title, 
      quantity, 
      image, 
      product_title, 
      best_price, 
      product_type, 
      type,
      shipping_size,
      Start, 
      End, 
      price,
      variant_ids
    } = v

    let single_price

    single_price = parseInt(price.replace(".", "")) / quantity

    let cent = single_price.toString().slice(-2)

    single_price = single_price.toString().slice(0,-2)
    single_price = `${single_price}.${cent}`

    let html_append = `
    <tr class="cart__row" data-cart-item="" data-cart-item-key="${key}" data-cart-item-url="${url}" data-cart-item-title="${title}" data-cart-item-index="" data-cart-item-quantity="${quantity}">
            <td class="cart__meta small--text-left" data-cart-table-cell="">
              <div class="cart__product-information">
                <div class="cart__image-wrapper">
                  <img class="cart__image" src="${image}" alt="" data-cart-item-image="" style="cursor: pointer;">
                </div>
                <div class="cart-detail-custom">
                  <div class="list-view-item__title">
                    <a href="${url}" class="cart__product-title" data-cart-item-title="">
                      ${product_title}
                    </a>
                  </div>
                  <ul class="product-details" data-cart-item-details1="" aria-label="Product details">
                    <li class="product-details__item product-details__item--variant-option hide" data-cart-item-option1="">
                      Rent Price: ${best_price}
                    </li>
                    <li class="product-details__item product-details__item--variant-option" data-cart-item-option2="">
                      Type: ${type}
                    </li>
                    <li class="product-details__item product-details__item--variant-option hide" data-cart-item-option3=""">
                      shipping-size: ${shipping_size}
                    </li>
                    <li class="product-details__item product-details__item--property hide" data-cart-item-property="">
                      <span class="product-details__item-label" data-cart-item-property-name="">
                        Best Price: 
                      </span>
                      <span data-cart-item-property-value="">
                        ${best_price}
                      </span>
                    </li>
                    <li class="product-details__item product-details__item--property" data-cart-item-property="" style="margin-top:0.8rem">
                      <span class="product-details__item-label" data-cart-item-property-name="">
                        Start: 
                      </span>
                      <span data-cart-item-property-value="">
                        ${Start}
                      </span>
                    </li>
                    <li class="product-details__item product-details__item--property" data-cart-item-property="">
                      <span class="product-details__item-label" data-cart-item-property-name="">
                        End: 
                      </span>
                      <span data-cart-item-property-value="">
                        ${End}
                      </span>
                    </li>
                  </ul>
                  
                  <p class="${product_type}">
                    <a style="cursor: pointer;" class="text-link text-link--accent remove-custom"data-cart-removena="${variant_ids}">Remove</a>
                  </p>
                </div>
              </div>
            </td>
            <td class="cart__price text-right"><div data-cart-item-price="">
              <dl data-cart-item-price-list=""><div class="hide" data-cart-item-discounted-price-group="">
                <dt>
                  <span class="visually-hidden">Regular price</span>
                </dt>
                <dd>
                  <s data-cart-item-original-price="">$${price}</s>
                </dd>
                <dt>
                  <span class="visually-hidden">Sale price</span>
                </dt>
                <dd>
                  <span class="order-discount" data-cart-item-final-price="">$${price}</span>
                </dd>
                </div><div data-cart-item-regular-price-group="">
                  <dt>
                    <span class="visually-hidden">Regular price</span>
                  </dt>
                  <dd data-cart-item-regular-price="">
                    $${single_price}
                  </dd>
                </div>
                <div class="hide" data-unit-price-group="">
                  <dt>
                    <span class="visually-hidden visually-hidden--inline">Unit price</span>
                  </dt>
                    <dd>
                      <span class="price-unit-price">
                        <span data-unit-price=""></span>
                        <span aria-hidden="true">/</span>
                        <span class="visually-hidden">per&nbsp;</span>
                        <span data-unit-price-base-unit=""></span>
                      </span>
                    </dd>
                </div>
              </dl>
              </div>
              <ul class="order-discount order-discount--list order-discount--title order-discount--cart hide" aria-label="Discount" data-cart-item-discount-list=""><li class="order-discount__item" data-cart-item-discount="">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg>
                    <span data-cart-item-discount-title=""></span> (-<span data-cart-item-discount-amount=""></span>)
                  </li>
              </ul>

              <div class="cart__qty medium-up--hide Mobility">
                <label for="" class="cart__qty-label" aria-label="Quantity" data-quantity-label-mobile="">
                  Qty
                </label>
                <input id="" class="cart__qty-input" type="number" value="${quantity}" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="${quantity}" data-quantity-input-mobile="">
              </div>
              <div class="cart__qty-error-message-wrapper cart__qty-error-message-wrapper--mobile hide" role="alert" data-cart-quantity-error-message-wrapper="">
                <span class="visually-hidden">Error </span>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg>
                <span class="cart__qty-error-message" data-cart-quantity-error-message=""></span>
              </div>
            </td>
            <td class="cart__quantity-td text-right small--hide">
              <div class="cart__qty Mobility">
                <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                <input id="" class="cart__qty-input" type="number" name="updates[]" value="${quantity}" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="${quantity}" data-quantity-input-desktop="">
              </div>
              <div class="cart__qty-error-message-wrapper cart__qty-error-message-wrapper--desktop hide" role="alert" data-cart-quantity-error-message-wrapper="">
                <span class="visually-hidden">Error </span>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg>
                <span class="cart__qty-error-message" data-cart-quantity-error-message=""></span>
              </div>
            </td>
            <td class="cart__final-price text-right small--hide" data-cart-item-line-price=""><dl class="hide" data-cart-item-discounted-price-group="">
                <dt>
                  <span class="visually-hidden">Regular total</span>
                </dt>
                <dd>
                  <s data-cart-item-original-price="">$${price}</s>
                </dd>
                <dt>
                  <span class="visually-hidden">Discounted total</span>
                </dt>
                <dd>
                  <span class="order-discount" data-cart-item-final-price="">$${price}</span>
                </dd>
              </dl><div data-cart-item-regular-price-group="">
                <span data-cart-item-regular-price="">$${price}</span>
              </div>
            </td>
          </tr>
    `
    
    $('tbody[data-cart-line-items]').append(html_append)

    $('.remove-custom').click(function (e){
      // console.log($(this).attr('data-cart-removena'));
      let exclude_variant = $(this).attr('data-cart-removena').split("_")
      let cart = jQuery.getJSON('/cart.js');
      cart.done(() => {
        cart = cart.responseJSON
        let items = cart.items
        console.log(items);

        items = items.filter((v) => {
          if (!exclude_variant.includes(v.id.toString())) {
            return {
              id: v.id,
              quantity: v.quantity
            }
          }
        })

        console.log(items);

        let clearItems = jQuery.post('/cart/clear.js')
        .done(() => {
          alert("berhasil")
        })
        .fail(() => {
          let addItems = jQuery.post('/cart/add.js', 
          {
            items: items
          })
          .done(() => {
            alert("berhasil")
          })
          .fail(() => {
            let this_url =  $(this).parent().parent().parent().parent().parent().attr('data-cart-item-url'),
            this_title = $(this).parent().parent().parent().parent().parent().attr('data-cart-item-title'),
            this_qty = $(this).parent().parent().parent().parent().parent().attr('data-cart-item-quantity'),
            this_best = $(this).parent().siblings().eq(1).children('.product-details__item--property').first().children().last().text().trim(),
            this_total_price = parseInt($(this).parent().parent().parent().parent().siblings().last().children().last().children().text().trim().replace("$", "").replace(".", "")),
            total_price = parseInt($('span.cart-subtotal__price[data-cart-subtotal]').text().replace("$", "").replace(".", "").replace("USD", ""))

            total_price -= this_total_price

            if (total_price == 0) {
              location.reload()
            }
            else{
              this_title = this_title.replace("Daily", this_best).replace("Weekly", this_best)
  
              $(this).parent().parent().parent().parent().parent().html(
                `<td class="cart__removed-product" data-cart-table-cell="" colspan="4">Removed <span class="cart__removed-product-details">(${this_qty}) <a href="${this_url}" class="text-link text-link--accent">${this_title}.</td>`
              )

              let cent = total_price.toString().slice(-2)
              total_price = total_price.toString().slice(0, -2)
              total_price = `$${total_price}.${cent} USD`

              $('span.cart-subtotal__price[data-cart-subtotal]').text(total_price)
            }
          })
        })
      })
    })

    $('li.product-details__item[data-cart-item-option2]').each(function (i,v) {
      if ($(this).text().trim() == 'Type: null') {
        // console.log($(this));
        // console.log($(this).text().trim());
        $(this).hide()
      }
    })
    // if ($('li.product-details__item[data-cart-item-option2]').text().trim() == 'Type: null') {
    //   console.log('noel');
    //   $('li.product-details__item[data-cart-item-option2]').hide()
    // }

    // console.log($('input.cart__qty-input'));
    
  })
  $('input.cart__qty-input').each(function (i,v) {
    $(this).attr('disabled', 'disabled')
  })
})

$('.cart__remove a[data-cart-remove]').click(function(){
  setTimeout(() => {
    location.reload()
  }, 1000);
})

$('.remove-custom').click(function(){
  setTimeout(() => {
    location.reload()
  }, 1000);
})
;!function(){if(window.jQuery||window.document){window.addEventListener('click',function(e){var t=e.target&&e.target.closest?e.target.closest('.cart__submit'):null;if(t){e.stopPropagation();var n=document.getElementById('agreement'),a=document.querySelector('.rental-agreement');if(n&&a&&!n.checked){e.preventDefault(),a.classList.remove('sme-bad'),a.offsetWidth,a.classList.add('sme-bad');var r=document.getElementById('smeHint');return r&&r.classList.add('on'),void a.scrollIntoView({block:'center',behavior:'smooth'})}e.preventDefault();var o=t.getAttribute('href')||'/checkout',d=!1,i=function(){d||(d=!0,window.location.href=o)};setTimeout(i,1200);try{fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Rental Agreement Accepted':(new Date).toISOString()}})}).then(i,i)}catch(e){i()}}},!0),'loading'===document.readyState?document.addEventListener('DOMContentLoaded',e):e(),setTimeout(e,1200)}function e(){!function(){if(!document.getElementById('smeCss')){var e=document.createElement('style');e.id='smeCss',e.textContent='.rental-agreement{display:block;width:100%;box-sizing:border-box;margin:18px 0 22px;padding:0;border:2px solid #f59e0b;border-radius:8px;background:#fff8e6;text-align:left;overflow:hidden;box-shadow:0 2px 10px rgba(0,0,0,.07)}.rental-agreement .sme-head{display:block;padding:11px 20px;background:#f59e0b;color:#1a1a1a;font-size:13px;font-weight:800;letter-spacing:.09em;text-transform:uppercase}.rental-agreement .sme-body{display:block;padding:18px 20px}.rental-agreement input[type=checkbox]{width:24px;height:24px;vertical-align:top;margin:1px 12px 0 0;accent-color:#0a7d33;cursor:pointer}.rental-agreement label{display:inline;cursor:pointer}.rental-agreement label p{display:inline;margin:0;font-size:16px;font-weight:600;line-height:1.55}.rental-agreement a{text-decoration:underline;font-weight:800;color:#1f3a68}.rental-agreement .sme-open{display:inline-block;margin:16px 0 0;padding:14px 26px;border:0;border-radius:6px;background:#1f3a68;color:#fff !important;font-size:15px;font-weight:800;letter-spacing:.02em;text-decoration:none !important;box-shadow:0 3px 8px rgba(31,58,104,.35);transition:background .15s,transform .1s}.rental-agreement .sme-open:hover{background:#16294a;color:#fff !important;transform:translateY(-1px)}.rental-agreement .sme-open:active{transform:translateY(0)}.rental-agreement.sme-ok .sme-open{background:#0a7d33;box-shadow:0 3px 8px rgba(10,125,51,.3)}.rental-agreement.sme-ok .sme-open:hover{background:#086628}.rental-agreement.sme-ok{border-color:#0a7d33;background:#f1faf4}.rental-agreement.sme-ok .sme-head{background:#0a7d33;color:#fff}.rental-agreement.sme-bad{border-color:#b00020;background:#fdecee;animation:smeShake .4s ease-in-out 2}.rental-agreement.sme-bad .sme-head{background:#b00020;color:#fff}@keyframes smeShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-7px)}75%{transform:translateX(7px)}}.cart__submit.sme-locked{opacity:.45 !important;filter:grayscale(80%) !important;cursor:not-allowed !important}.cart__submit:not(.sme-locked){opacity:1 !important;filter:none !important;cursor:pointer !important}.sme-hint{display:none;margin:8px 0 0;font-size:14px;font-weight:700;color:#b00020;line-height:1.4}.sme-hint.on{display:block}.sme-ack,.sme-ack-btn,.sme-ack-err,.sme-dead{display:none !important}',(document.head||document.documentElement).appendChild(e)}}(),function(){if(document.body){for(var e,t=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,!1),n=[];e=t.nextNode();){var a=e.nodeValue||'';(a.indexOf('.sme-ack{')>-1||a.indexOf('.sme-ack-btn{')>-1||a.indexOf('smeAckErr')>-1)&&n.push(e)}for(var r=0;r<n.length;r++)n[r].nodeValue=''}}();var e=document.getElementById('agreement'),t=document.querySelector('.rental-agreement'),n=document.querySelector('.cart__submit');if(e&&t&&n){if(!t.querySelector('.sme-head')){var a=document.createElement('div');a.className='sme-head',a.textContent='Step 1 of 2 - Rental Agreement required';var r=document.createElement('div');for(r.className='sme-body';t.firstChild;)r.appendChild(t.firstChild);t.appendChild(a),t.appendChild(r);var o=document.createElement('a');o.className='sme-open',o.href='/pages/rental-agreement',o.target='_blank',o.rel='noopener',o.textContent='Read and Accept the Rental Agreement',r.appendChild(document.createElement('br')),r.appendChild(o)}if(e.setAttribute('autocomplete','off'),e.checked=!1,n.classList.add('sme-locked'),n.setAttribute('aria-disabled','true'),n.setAttribute('disabled','disabled'),!document.getElementById('smeHint')){var d=document.createElement('p');d.id='smeHint',d.className='sme-hint',d.textContent='Accept the Rental Agreement above to continue.',n.parentNode.appendChild(d)}e.addEventListener('change',function(){t.classList.remove('sme-bad'),t.classList.toggle('sme-ok',this.checked),n.classList.toggle('sme-locked',!this.checked),n.setAttribute('aria-disabled',this.checked?'false':'true'),this.checked?n.removeAttribute('disabled'):n.setAttribute('disabled','disabled');var e=document.getElementById('smeHint');e&&e.classList.toggle('on',!this.checked);var a=t.querySelector('.sme-head');a&&(a.textContent=this.checked?'Rental Agreement accepted - you can check out':'Step 1 of 2 - Rental Agreement required')})}}}();